import styles from "./style.module.css";

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import {
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  RedditIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";
import { Icon, Popup } from "semantic-ui-react";

export default function ShareButtonRow({
  postUrl,
  companyName,
  jobTitle,
  hideWhatsapp,
  hideEmail,
  hideReddit,
  linkOnly,
}) {
  const ShareContent = () => {
    const openPop = () => {
      navigator.clipboard.writeText(postUrl);
    };

    const titleString = `${jobTitle} @  ${companyName} - now hiring!`;
    const summaryString = `Find the best remote and hybrid jobs on LifeShack.com`;
    const sourceString = `www.LifeShack.com`;

    const handleClick = (e) => {
      e.stopPropagation();
    };

    if (linkOnly) {
      return (
        <Popup
          content="Link copied!"
          on="click"
          onOpen={openPop}
          trigger={
            <div className={styles.shareWrap}>
              <div className={styles.webShare}>
                <Icon name="linkify" color={"white"} />
              </div>
            </div>
          }
        />
      );
    }

    return (
      <div className={styles.shareLinks} onClick={handleClick}>
        <Popup
          content="Link copied!"
          on="click"
          onOpen={openPop}
          trigger={
            <div className={styles.shareWrap}>
              <div className={styles.webShare}>
                <Icon name="linkify" color={"white"} />
              </div>
            </div>
          }
        />

        <div className={styles.shareWrap}>
          <LinkedinShareButton
            title={titleString}
            summary={summaryString}
            source={sourceString}
            url={postUrl}
          >
            <LinkedinIcon round={true} size={33} />
          </LinkedinShareButton>
        </div>

        <div className={styles.shareWrap}>
          <FacebookShareButton
            quote={titleString}
            hashtag={`#remotework`}
            url={postUrl}
          >
            <FacebookIcon round={true} size={33} />
          </FacebookShareButton>
        </div>

        {!hideReddit && (
          <div className={styles.shareWrap}>
            <RedditShareButton title={titleString} url={postUrl}>
              <RedditIcon round={true} size={33} />
            </RedditShareButton>
          </div>
        )}

        <div className={styles.shareWrap}>
          <TwitterShareButton
            title={titleString}
            via={"LifeShack.com"}
            hashtags={["remotejobs", "remotework", "hiring"]}
            url={postUrl}
          >
            <TwitterIcon round={true} size={33} />
          </TwitterShareButton>
        </div>

        {!hideEmail && (
          <div className={styles.shareWrap}>
            <EmailShareButton
              title={titleString}
              body={`Check out this remote job on LifeShack.com`}
              url={postUrl}
            >
              <EmailIcon round={true} size={33} />
            </EmailShareButton>
          </div>
        )}

        {!hideWhatsapp && (
          <div className={styles.shareWrap}>
            <WhatsappShareButton title={titleString} url={postUrl}>
              <WhatsappIcon round={true} size={33} />
            </WhatsappShareButton>
          </div>
        )}
      </div>
    );
  };

  return <ShareContent />;
}
